export class DateUtils {

	static getFormattedDate(dateObject: Date): string {
		return dateObject.toLocaleDateString('ru');
	}

	static getFormattedTime(dateObject: Date): string {
		return dateObject.toLocaleTimeString('ru');
	}

	static getFormattedDateTime(dateObject: Date): string {
		return `${DateUtils.getFormattedDate(dateObject)} ${DateUtils.getFormattedTime(dateObject)}`;
	}

	static getFormattedTimeDate(dateObject: Date): string {
		return `${DateUtils.getFormattedTime(dateObject).slice(0, 5)}, ${DateUtils.getFormattedDate(dateObject)}`;
	}

	static getISODate(dateObject: Date): string {
		return DateUtils.getFormattedDate(dateObject).split('.').reverse().join('-');	
	}

}